import { render, staticRenderFns } from "./Promotions.vue?vue&type=template&id=00e2d850&scoped=true"
import script from "./Promotions.vue?vue&type=script&lang=js"
export * from "./Promotions.vue?vue&type=script&lang=js"
import style0 from "./Promotions.vue?vue&type=style&index=0&id=00e2d850&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e2d850",
  null
  
)

export default component.exports